export const AVAIL_ENDPOINT = 'availmessages';
export const AVAIL_ERRORS_ENDPOINT = 'availerrors';

export const availableAvailSearchOptions = [
  {
    value: 'alid',
    title: 'ALID',
  },
  {
    value: 'eidr',
    title: 'EditEIDR',
  },
  {
    value: 'title',
    title: 'Title',
  },
  {
    value: 'tier',
    title: 'Tier',
  },
];

export const availableSearchTypes = [
  {
    value: AVAIL_ERRORS_ENDPOINT,
    title: 'Avail Errors',
  },
  {
    value: AVAIL_ENDPOINT,
    title: 'Avail Messages',
  },
];

export const availableErrorSearchOptions = [
  {
    value: 'alid',
    title: 'ALID',
  },
  {
    value: 'eidr',
    title: 'EditEIDR',
  },
];

export const availablePriceSearchParams = [
  {
    value: 'value',
    title: 'Value',
  },
  {
    value: 'type',
    title: 'Transaction Type',
  },
  {
    value: 'currency',
    title: 'Currency',
    optional: true,
  },
];

export const filterTypes = [
  {
    name: 'system',
    options: [
      {
        value: '*',
        title: 'All',
      },
      {
        value: 'aulone',
        title: 'Aulone',
      },
      {
        value: 'ascendon',
        title: 'Ascendon',
      },
      {
        value: 'metacloud',
        title: 'Metacloud',
      },
      {
        value: 'sandwich',
        title: 'Sandwich',
      },
    ],
  },
  {
    name: 'severity',
    options: [
      {
        value: '*',
        title: 'All',
      },
      {
        value: 'WARNING',
        title: 'Warning',
      },
      {
        value: 'ERROR',
        title: 'Error',
      },
      {
        value: 'FATAL',
        title: 'Fatal',
      },
      {
        value: 'FUNCTIONAL',
        title: 'Functional',
      },
      {
        value: 'INFORMATIONAL',
        title: 'Informational',
      },
      {
        value: 'DEBUG',
        title: 'Debug',
      },
    ],
  },
];

export const limitParamsOptions = [
  {
    value: '10',
    title: '10',
  },
  {
    value: '25',
    title: '25',
  },
  {
    value: '50',
    title: '50',
  },
  {
    value: '100',
    title: '100',
  },
  {
    value: '300',
    title: '300',
  },
];
